/* eslint-disable react-hooks/exhaustive-deps */
// import TicketMenuManagementCreate from "./lib/create";
import { useParams } from 'react-router';
import { useEffect } from 'react';

import { useTypedSelector } from 'common/hooks/useTypedSelector';
import TicketDetailInfo from './lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';

import PageTitle from 'components/pageTitle';

import * as S from './styles';
// import TicketDetailTypeInfo from './lib/typeInfo';

export default function TicketDetailPage() {
  const { ticketDetail, ticketClose } = useTypedSelector((state) => state.Tickets);
  const { ticketDetailRequestActionNew } = useActions();

  const params = useParams();

  useEffect(() => {
    ticketDetailRequestActionNew(params?.id);
  }, []);

  return (
    <S.Container>
      <PageTitle title="Tickets" />

      <TicketDetailInfo data={ticketDetail.data} />

      <AppLoading loading={ticketDetail.loading || ticketClose.loading} />
    </S.Container>
  );
}
